export { ScrollArea } from './scroll-area';
export type {
  ScrollAreaStylesNames,
  ScrollAreaProps,
  ScrollAreaAutosizeProps,
} from './scroll-area';
export type { ScrollAreaStylesParams } from './scroll-area.styles';
